/* eslint-disable no-else-return */
import { useTranslation } from 'react-i18next';
import { EmployeePermissionsEnum, PermissionGroupKey } from './teamPermission.constant';
import { PermissionGroupType } from './teamPermission.interface';
import { useStoreState } from '../../../../models/hooks';

export const usePermissionGroup = () => {
  const { t } = useTranslation('team');
  const isHireFormTemplateEnabled = useStoreState((s) => s.app.accounts?.configuration?.hireFormTemplateEnabled);
  const isCertnEnabled = useStoreState((s) => s.app.accounts?.configuration?.certnEnabled);
  const isI9CheckEnabled = useStoreState((s) => s.app.accounts?.configuration?.i9CheckEnabled);

  const permissionGroups: PermissionGroupType[] = [
    {
      heading: t('permissionModal.backgroundCheck.heading'),
      groupKey: PermissionGroupKey.BACKGROUND_CHECK,
      permissions: [
        {
          title: t('permissionModal.backgroundCheck.admin.title'),
          description: t('permissionModal.backgroundCheck.admin.description'),
          key: EmployeePermissionsEnum.BACKGROUND_CHECK_ADMIN,
          info: t('hasAdminAccess'),
        },
        {
          title: t('permissionModal.backgroundCheck.request.title'),
          description: t('permissionModal.backgroundCheck.request.description'),
          key: EmployeePermissionsEnum.BACKGROUND_CHECK_REQUEST,
          info: t('hasRequestAccess'),
        },
        {
          title: t('permissionModal.backgroundCheck.review.title'),
          description: t('permissionModal.backgroundCheck.review.description'),
          key: EmployeePermissionsEnum.BACKGROUND_CHECK_REVIEW,
          info: t('hasReviewAccess'),
        },
      ],
    },
    {
      heading: t('permissionModal.hrForm.heading'),
      groupKey: PermissionGroupKey.HR_FORM,

      permissions: [
        {
          title: t('permissionModal.hrForm.admin.title'),
          description: t('permissionModal.hrForm.admin.description'),
          key: EmployeePermissionsEnum.HR_ADMIN,
          info: t('hasAdminAccess'),
        },
        {
          title: t('permissionModal.hrForm.request.title'),
          description: t('permissionModal.hrForm.request.description'),
          key: EmployeePermissionsEnum.HR_REQUEST,
          info: t('hasRequestAccess'),
        },
        {
          title: t('permissionModal.hrForm.review.title'),
          description: t('permissionModal.hrForm.review.description'),
          key: EmployeePermissionsEnum.HR_REVIEW,
          info: t('hasReviewAccess'),
        },
      ],
    },
    {
      heading: t('permissionModal.i9Form.heading'),
      groupKey: PermissionGroupKey.I9,

      permissions: [
        {
          title: t('permissionModal.i9Form.admin.title'),
          description: t('permissionModal.i9Form.admin.description'),
          key: EmployeePermissionsEnum.I9_ADMIN,
          info: t('hasAdminAccess'),
        },
        {
          title: t('permissionModal.i9Form.request.title'),
          description: t('permissionModal.i9Form.request.description'),
          key: EmployeePermissionsEnum.I9_REQUEST,
          info: t('hasRequestAccess'),
        },
        {
          title: t('permissionModal.i9Form.review.title'),
          description: t('permissionModal.i9Form.review.description'),
          key: EmployeePermissionsEnum.I9_REVIEW,
          info: t('hasReviewAccess'),
        },
      ],
    },
  ]?.filter((group) => {
    if (group.groupKey === PermissionGroupKey.HR_FORM && isHireFormTemplateEnabled) {
      return true;
    } else if (group.groupKey === PermissionGroupKey.BACKGROUND_CHECK && isCertnEnabled) {
      return true;
    } else if (group.groupKey === PermissionGroupKey.I9 && isI9CheckEnabled) {
      /* istanbul ignore else */
      return true;
    } else {
      return false;
    }
  });

  return { permissionGroups };
};
